import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Layout/AuthLayout.vue';

import NotFound from '@/views/NotFoundPage.vue';

const routes = [
  {
    path: '/',
    redirect: 'dashboard',
    component: DashboardLayout,
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "demo" */ '../views/Dashboard.vue')
      },
      {
        path: '/icons',
        name: 'icons',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Icons.vue')
      },
      {
        path: '/profile',
        name: 'profile',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/UserProfile/UserProfile.vue')
      },
      {
        path: '/domain/:id',
        name: 'domain',
        props:true,
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Domain/Domain.vue')
      },
      {
        path: '/domains',
        name: 'domains',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Domain/Domains.vue')
      },
      {
        path:'/brands',
        name: 'brands',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Brand/Brands.vue')
      },
      {
        path:'/brand/:id',
        name:'brand',
        props:true,
        component: () => import('../views/Pages/Brand/Brand.vue')
      },
      {
        path: '/job_histories',
        name: 'job histories',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/JobHistory/JobHistories.vue')
      },
      {
        path: '/job_history/:id',
        name:'job history',
        props:true,
        component: () => import('../views/Pages/JobHistory/JobHistory.vue')
      },
      {
        path:'/job_groups',
        name:'job groups',
        component: () => import('../views/Pages/JobGroup/JobGroups.vue')
      },
      {
        path:'/job_group/:id',
        name:'job group',
        props:true,
        component: () => import('../views/Pages/JobGroup/JobGroup.vue')
      },
      {
        path: '/job_group_histories',
        name: 'job group histories',
        component: () => import('../views/Pages/JobGroupHistory/JobGroupHistories.vue')
      },
      {
        path: '/job_group_history/:id',
        name:'job group history',
        props:true,
        component: () => import('../views/Pages/JobGroupHistory/JobGroupHistory.vue')
      },
      {
        path:'/location_reports',
        name:'location reports',
        component:() => import('../views/Pages/LocationReport/LocationReports.vue')
      },
      {
        path: '/location_report/:id',
        name:'location report',
        props:true,
        component: () => import('../views/Pages/LocationReport/LocationReport.vue')
      },
      {
        path:'/popularity',
        name:'popularity',
        component:() => import('../views/Pages/Popularity/PopularityList.vue')
      },
      {
        path:'/popularity/:id',
        name:'popularity detail',
        props:true,
        component: () => import('../views/Pages/Popularity/Popularity.vue')
      }
    ]
  },
  {
    path: '/',
    redirect: 'login',
    component: AuthLayout,
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/UserAuth/Login.vue')
      },
      {
        path: '/register',
        name: 'register',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/UserAuth/Register.vue')
      },
      {
        path:'/logout',
        name:'logout',
        component: () => import('../views/Pages/UserAuth/Logout.vue')
      },
      { path: '*', component: NotFound }
    ]
  }
];

export default routes;
